import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout route for the invoices sub-tree (register at `/sales-invoicing/
 * invoices`, detail at `/sales-invoicing/invoices/$invoiceId`) — mirrors
 * `silo-counts/counts.tsx`'s identical pattern. */
export const Route = createFileRoute('/_authenticated/sales-invoicing/invoices')({
  component: () => <Outlet />,
});
